export default __webpack_public_path__ + "media/music/036bf00e97ec420e2462bd70f764d429.mp3";